import { createSelector } from 'reselect';

export const selectProfileState = (state) => state.profile;

const selectUpdatedProfileState = (profile) => profile && profile.updatedProfile;

export const makeSelectProfile = () => createSelector(
  selectProfileState,
  selectUpdatedProfileState,
);

const selectLoadedProfileState = (profile) => profile && profile.loaded;

export const makeSelectLoaded = () => createSelector(
  selectProfileState,
  selectLoadedProfileState,
);

const selectErrorProfileState = (profile) => profile && profile.error;

export const makeSelectError = () => createSelector(
  selectProfileState,
  selectErrorProfileState,
);

export const selectIsSubmitting = (profile) => profile && profile.isSubmitting;
